export default __webpack_public_path__ + "static/media/carwash-detail.03e8bcfe.webp";